export const container = {
    gutter: '15px',
    maxWidth: '1170px',
    borderRadius: '6px',
};
